__turbopack_context__.v({
  "content": "site-notifications-modal-module-sass-module__2j_HLq__content",
  "header": "site-notifications-modal-module-sass-module__2j_HLq__header",
  "item": "site-notifications-modal-module-sass-module__2j_HLq__item",
  "notificationsCarousel": "site-notifications-modal-module-sass-module__2j_HLq__notificationsCarousel",
  "siteNotifications": "site-notifications-modal-module-sass-module__2j_HLq__siteNotifications",
  "siteNotificationsModal": "site-notifications-modal-module-sass-module__2j_HLq__siteNotificationsModal",
  "title": "site-notifications-modal-module-sass-module__2j_HLq__title",
});
